import _ from 'lodash';
import {
    FETCH_RAINPRO_SCHEMES,
    CLEAN_RAINPRO_SCHEMES,
    CHANGE_RAINPRO_SCHEME,
    DELETE_RAINPRO_SCHEME,
} from './types';
import { request, __ } from '../functions';

export const fetchRainproSchemes = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/rainpro/schemes', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_SCHEMES, payload: data });
    });
};

export const changeRainproScheme = (screen, id, data) => {
    return dispatch => request(`/rainpro/editScheme/${id}`, { data }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť schému'));
            return;
        }

        screen.showSnackbar('success', __('Schéma bola zmenená'));

        dispatch({ type: CHANGE_RAINPRO_SCHEME, payload: { id, data } });
    });
};

export const deleteRainproScheme = (screen, id) => {
    return dispatch => request(`/rainpro/removeScheme/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať schému'));
            return;
        }

        screen.showSnackbar('success', __('Schéma bola zmazaná'));

        dispatch({ type: DELETE_RAINPRO_SCHEME });
    });
};

export const cleanRainproSchemes = () => ({ type: CLEAN_RAINPRO_SCHEMES });
